import { useEffect, useState } from "react";
import useJSONActions from "../../../hooks/use-json-actions";
import Popover from "react-bootstrap/Popover";
import FormBlock from "../FormBlock";
import Icon from "../../../icons/Icon";

const PopoverForm = ({id,setShow, url, action, formIndex, popover, selectedValue, className, children, saveHook}) => {
    const [formUrl, setFormUrl] = useState(url);
    const getJsonActions = useJSONActions()

    useEffect(() => {
        if(!action){}
        else if(action.form_url){
            setFormUrl(action.form_url)
        }
        else if(action){
            action = getJsonActions(null, {'action_id':action.action_id })
            setFormUrl(action[0].form_url)
        }
    }, [action]);
    useEffect(() => {
        setFormUrl(url)
    }, [url]);

    const localSaveHook = (forms, index) => {
        if(forms[index].success){
            if(forms.every(form => form.success)){
                setShow && setShow(false)
            }
            saveHook && saveHook(forms, index)
        }
    }

    return <Popover className="form-popover pb-0 bg-white rounded" arrowProps={{className: ' d-none'}}>
            <a type="button" className={"m-1 position-sticky top-0 bg-white z-1"} onClick={() => setShow && setShow(false)}>
                <Icon name={"ICON_X"} />
            </a>
            <FormBlock 
                className={className} 
                url={formUrl} 
                saveHook={localSaveHook} 
            />
    </Popover>
       
}

export default PopoverForm;